import request from '@/utils/request';
export const defaultLedgerData = {
  id: 0,
  dealerId: undefined,
  ordersDispatchId: undefined,
  transactionId: undefined,
  amount: 0,
  action: '',
  comments: null,
  paymentType: null,
  paymentSubType: null,
  status: null,
  dealer: {
    id: null
  },
  ordersDispatch: {
    id: null
  },
  transaction: {
    id: null
  },
  quantity: undefined,
  productId: undefined,
  productsVariationId: undefined,
  CnDnProducts: [],
  isCnDn: false,
  isNew: false,
  dealersTransporterId: undefined,
  adminId: null,
  unitId: null,
  billingAddressId: null,
  deliveryAddressId: null,
  journalReceiptBillNo: null,
  replacementNumber: null,
  createdBy: null,
  taxedAmount: 0,
  approvalStatus: null,
  ledgerAttachmentS3Url: null,
  bank: null,
  fromTally: false,
  applyGST: false,
  gstType: null,
  gstAmount: 0,
  actualCreatedTimestamp: null,
  isSales: true,
  returnPaymentType: null,
  returnPaymentMode: null,
  returnPaymentDocumentNumber: null,
  returnPaymentFavouringParty: null
};
export const getLedgers = params => request({
  url: '/ledgers',
  method: 'get',
  params
});
export const getLedgerById = id => request({
  url: `/ledgers/${id}`,
  method: 'get'
});
export const updateLedger = (id, data) => request({
  url: `/ledgers/${id}`,
  method: 'patch',
  data
});
export const updateLedgerEntry = (id, data) => request({
  url: `/ledgers/update-ledger-entry/${id}`,
  method: 'patch',
  data
});
export const deleteEntry = id => request({
  url: `/ledgers/delete-ledger-entry/${id}`,
  method: 'delete'
});
export const approveLedger = data => request({
  url: '/ledgers/approve-ledger/',
  method: 'post',
  data
});
export const removeCreditNoteItemWiseLedgers = data => request({
  url: '/ledgers/remove-item-wise',
  method: 'post',
  data
});
export const approveRequestApprovalLedger = data => request({
  url: '/ledgers/approve-request-approval-ledgers/',
  method: 'post',
  data
});
export const removedPaymentTypeLedgers = data => request({
  url: '/ledgers/remove-payment-wise',
  method: 'post',
  data
});
export const deleteLedger = id => request({
  url: `/ledgers/${id}`,
  method: 'delete'
});
export const deleteRequestApprovalLedger = id => request({
  url: `ledgers/request-approval-ledgers/${id}`,
  method: 'delete'
});
export const createLedger = data => request({
  url: '/ledgers/',
  method: 'post',
  data
});
export const getLedgerList = data => request({
  url: '/ledgers/list',
  method: 'post',
  data
});
export const getPendingPaymentLedgerList = params => request({
  url: '/ledgers',
  method: 'get',
  params
});
export const getApprovedLedgerList = params => request({
  url: '/ledgers',
  method: 'get',
  params
});
export const getPendingPaymentLedgerCount = params => request({
  url: '/ledgers/pending-ledgers',
  method: 'get',
  params
});
export const addLedgerTransaction = data => request({
  url: '/ledgers/add',
  method: 'post',
  data
});
export const updateLedgerItemWise = data => request({
  url: '/ledgers/update/item-wise',
  method: 'patch',
  data
});
export const downloadExcel = data => request({
  url: '/ledgers/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
export const downloadPDF = data => request({
  url: '/ledgers/download-pdf',
  method: 'post',
  data
});
export const generateInvoice = id => request({
  url: `/ledgers/generate-invoice/${id}`,
  method: 'get'
});
export const viewDispatchInvoice = id => request({
  url: `/orders-dispatches/get-invoice/${id}`,
  method: 'get'
});
export const viewCNDNInvoice = id => request({
  url: `/ledgers/ledger-pdf/${id}`,
  method: 'get'
});
export const generateEInvoice = id => request({
  url: `/ledgers/generate-einvoice/${id}`,
  method: 'get'
});
export const generateEway = id => request({
  url: `/ledgers/generate-eway/${id}`,
  method: 'get'
});
export const averageDealerData = data => request({
  url: '/ledgers/avg-dealer-data',
  method: 'post',
  data
});
export const downloadAverageExcel = data => request({
  url: '/ledgers/download-average-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
export const updateNarration = (id, data) => request({
  url: `/ledgers/update-narration/${id}`,
  method: 'patch',
  data
});
export const makeAdjustments = data => request({
  url: '/ledgers/depot-transit-adjustment',
  method: 'post',
  data
});
export const getRequestApprovalInfo = id => request({
  url: `/ledgers/request-approval-info/${id}`,
  method: 'get'
});
export const updateRequestApprovalLedger = data => request({
  url: '/ledgers/request-approval-ledger-edit',
  method: 'post',
  data
});
export const getLedgersPaymentTypeWise = params => request({
  url: '/ledgers/payment-type-wise',
  method: 'get',
  params
});
export const getLedgersPaymentTypeWiseExcel = params => request({
  url: '/ledgers/payment-type-wise/excel',
  method: 'get',
  params,
  responseType: 'blob'
});
export const getOverdueInvoices = params => request({
  url: '/ledgers/get-overdue-invoices',
  method: 'get',
  params
});
export const downloadOverdueInvoicesExcel = params => request({
  url: '/ledgers/get-overdue-invoices/excel',
  method: 'get',
  params,
  responseType: 'blob'
});
export const sendOverdueReminderMessage = () => request({
  url: '/ledgers/send-overdue-invoices-message',
  method: 'get'
});
export const createDebitNoteForInterest = () => {
  request({
    url: '/ledgers/create-debit-note-for-overdue-invoices',
    method: 'get'
  });
};
export const importLedgers = data => request({
  url: '/ledgers/import-ledgers',
  method: 'post',
  data
});